import { INavigationElement } from 'src/app/components/navigation-bar/INavigationElement';
import { APPLICATION_TYPES } from 'src/app/model/constants/application-types';
import { PAGE_NAMES } from 'src/app/service/ansokan-form-builder/application-names';
import { ANSOKAN_ROUTING_NAMES } from './ansokan.routes.names';

export function GET_PAGE_FLOW(type: string) {
    switch (type) {
        case APPLICATION_TYPES.NEW_SWEDISH:
            return NEW_APPLICATION_PAGE_FLOW;
        case APPLICATION_TYPES.SUPPLEMENT_SWEDISH:
            return SUPPLEMENT_APPLICATION_PAGE_FLOW;
    }
}

const NEW_APPLICATION_PAGE_FLOW: INavigationElement[] = [
    { index: ANSOKAN_ROUTING_NAMES.START, pageGroup: null, text: 'Start' },
    { index: ANSOKAN_ROUTING_NAMES.CONTACT_INFO, pageGroup: PAGE_NAMES.APPLICANT.KEY, text: 'Kontaktuppgifter' },
    { index: ANSOKAN_ROUTING_NAMES.DEGREE, pageGroup: PAGE_NAMES.DEGREE.KEY, text: 'Din examen' },
    { index: ANSOKAN_ROUTING_NAMES.SPECIAL_EDUCATION_TEACHER, pageGroup: PAGE_NAMES.SPECIAL_EDUCATION.KEY, text: 'Speciallärare' },
    {
        index: ANSOKAN_ROUTING_NAMES.VOCATIONAL_QUALIFICATION,
        pageGroup: PAGE_NAMES.VOCATIONAL_QUALIFICATION.KEY,
        text: 'Yrkesämnen',
    },
    {
        index: ANSOKAN_ROUTING_NAMES.OTHER_QUALIFICATION,
        pageGroup: PAGE_NAMES.OTHER_QUALIFICATION.KEY,
        text: 'Övriga behörigheter',
    },
    { index: ANSOKAN_ROUTING_NAMES.ATTACHMENT, pageGroup: PAGE_NAMES.ATTACHMENTS.KEY, text: 'Bilagor' },
    { index: ANSOKAN_ROUTING_NAMES.REVIEW, pageGroup: null, text: 'Granska' },
];

const SUPPLEMENT_APPLICATION_PAGE_FLOW: INavigationElement[] = [
    { index: ANSOKAN_ROUTING_NAMES.START, pageGroup: null, text: 'Start' },
    { index: ANSOKAN_ROUTING_NAMES.CONTACT_INFO, pageGroup: PAGE_NAMES.APPLICANT.KEY, text: 'Kontaktuppgifter' },
    { index: ANSOKAN_ROUTING_NAMES.SPECIAL_EDUCATION_TEACHER, pageGroup: PAGE_NAMES.SPECIAL_EDUCATION.KEY, text: 'Speciallärare' },
    {
        index: ANSOKAN_ROUTING_NAMES.VOCATIONAL_QUALIFICATION,
        pageGroup: PAGE_NAMES.VOCATIONAL_QUALIFICATION.KEY,
        text: 'Yrkesämnen',
    },
    {
        index: ANSOKAN_ROUTING_NAMES.OTHER_QUALIFICATION,
        pageGroup: PAGE_NAMES.OTHER_QUALIFICATION.KEY,
        text: 'Övriga behörigheter',
    },
    { index: ANSOKAN_ROUTING_NAMES.ATTACHMENT, pageGroup: PAGE_NAMES.ATTACHMENTS.KEY, text: 'Bilagor' },
    { index: ANSOKAN_ROUTING_NAMES.REVIEW, pageGroup: null, text: 'Granska' },
];
